
<div class="carga"  *ngIf="(!this.flagCargaGrafica)"> 
  <h1> CARGANDO DATOS...</h1>
  <mat-spinner class="spinner"></mat-spinner> 
</div>

<div class="chart">
  <canvas id="barChart" #barChart>{{chart}}</canvas>
</div>

